module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/core-js/modules/_path.js
// module id = 501
// module chunks = 2 3 4 5 6 7 8 9 10 11 12